import { initialize } from 'launchdarkly-js-client-sdk';

export default defineNuxtPlugin({
  name: 'launch-darkly',
  async setup() {
    const config = useRuntimeConfig();

    const user = {
      anonymous: config.public.launchdarkly.anonymous,
      key: config.public.launchdarkly.user,
    };

    const ldClient = initialize(config.public.launchdarkly.clientId, user);
    await ldClient.waitUntilReady();

    return {
      provide: {
        ldClient,
      },
    };
  },
});
